"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _ServiceItem = _interopRequireDefault(require("./optional-items/ServiceItem"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    .col-xs-6 {\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledH1 = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "Services__StyledH1",
  componentId: "sc-7h01zc-0"
})(["margin-bottom:8px !important;"]);
var ButtonGrid = (0, _styledComponents.default)(_UIGrid.default).withConfig({
  displayName: "Services__ButtonGrid",
  componentId: "sc-7h01zc-1"
})(["", ";"], _responsiveBreakpoints.default.tablet(_templateObject()));

function Services(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return _react.default.createElement("div", {
    className: "m-bottom-12"
  }, _react.default.createElement(StyledH1, null, title), subtitle, _react.default.createElement(ButtonGrid, {
    className: "m-top-4"
  }, _react.default.createElement(_ServiceItem.default, {
    merchandiseId: _MerchandiseIds.SERVICE_INBOUND_CONSULTING_MONTHLY
  }), _react.default.createElement(_ServiceItem.default, {
    merchandiseId: _MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONGOING
  }), _react.default.createElement(_ServiceItem.default, {
    merchandiseId: _MerchandiseIds.SERVICE_TECHNICAL_CONSULTING_ONGOING
  }), _react.default.createElement(_ServiceItem.default, {
    merchandiseId: _MerchandiseIds.SERVICE_PREMIUM_CONSULTING
  }), _react.default.createElement(_ServiceItem.default, {
    merchandiseId: _MerchandiseIds.SERVICE_TRAINING_MARKETING_FUNDAMENTALS
  })));
}

var _default = Services;
exports.default = _default;
module.exports = exports.default;